import React, { useEffect, useState } from 'react';
import { FormControl, InputAdornment, OutlinedInput, Theme } from '@quillbot/design-system';
import { makeStyles } from '@mui/styles';
import SearchIcon from '@mui/icons-material/Search';
import { useDebounceState } from 'src/_common/hooks';
import { useRouter } from 'next/router';
import { setSearchQuery } from '../context/actionCreators';
import { useCitationGeneratorDispatch } from '../context';

const useStyles = makeStyles((theme: Theme) => ({
  inputAdornment: {
    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
  input: {
    paddingTop: ({ pathname }: { pathname: string }) =>
      pathname.includes('/co-writer') ? '18px' : '16px',
    fontWeight: ({ pathname }: { pathname: string }) =>
      pathname.includes('/co-writer') ? 400 : 600,
    fontSize: ({ pathname }: { pathname: string }) =>
      pathname.includes('/co-writer') ? 16 : undefined,
    '&::placeholder': {
      fontWeight: 'normal',
      color: ({ pathname }: { pathname: string }) =>
        pathname.includes('/co-writer') ? theme.palette.text.disabled : undefined,
    },
  },
  adornedStart: {
    paddingLeft: 0,
  },
  notchedOutline: {
    borderColor: '#c2c2c2',
  },
}));

interface SearchBoxProps {
  // submitSearchQuery: (query: string, type: SearchCategories) => void;
  maxWidth?: string;
  disabled?: boolean;
}

export const useCitationSearchQuery = (initialValue = '') => {
  const citationGeneratorDispatch = useCitationGeneratorDispatch();
  const [query, setQuery] = useState(initialValue);
  const debounceQuery = useDebounceState<string>(query);

  useEffect(() => {
    citationGeneratorDispatch(setSearchQuery(debounceQuery));
  }, [debounceQuery]);

  const immediateTrigger = () => {
    citationGeneratorDispatch(setSearchQuery(query));
  };

  return { query, setQuery, debounceQuery, immediateTrigger };
};

export default function CitationSearchBar({ maxWidth, disabled }: SearchBoxProps) {
  const router = useRouter();
  const classes = useStyles(router);
  const { query, setQuery, immediateTrigger } = useCitationSearchQuery('');

  return (
    <>
      <FormControl
        fullWidth
        disabled={disabled}
        style={{
          maxWidth,
        }}
      >
        <OutlinedInput
          disabled={disabled}
          value={query}
          inputProps={{
            'aria-label': 'weight',
          }}
          style={{
            height: '32px',
            paddingLeft: '6px',
            fontSize: '13px',
          }}
          placeholder="Search citation"
          autoComplete="off"
          classes={{
            input: classes.input,
            notchedOutline: classes.notchedOutline,
            // adornedStart: classes.adornedStart,
          }}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            setQuery(e.target.value);
          }}
          onKeyUp={() => {
            // citationGeneratorDispatch(setSearchQuery(query));
            immediateTrigger();
          }}
          id="outlined-adornment-amount"
          startAdornment={
            <InputAdornment
              position="start"
              className={classes.inputAdornment}
              /* onClick={() => {
                citationGeneratorDispatch(setSearchQuery(debounceQuery));
              }} */
              disablePointerEvents={disabled}
            >
              <SearchIcon
                style={{
                  color: disabled ? '#A0A0A0' : '#5F6368',
                }}
              />
            </InputAdornment>
          }
        />
      </FormControl>
    </>
  );
}
